module.exports = __webpack_public_path__ + "static/media/fotoarkiv.df2bcadc.png";